import React from 'react';
import PropTypes from 'prop-types';
import { BootstrapModal } from 'shared-components/modal/bootstrap-modal';
import { SocialButtons } from '../elements-buttons/social-buttons';

class ListingShareBtn extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      showModal: false
    };

    this.openShareModal = this.openShareModal.bind(this);
  }

  openShareModal (e) {
    if (e) {
      e.preventDefault();
    }

    const { listing, origin } = this.props;
    analyticsIntegrations.shareModalView(listing, origin);
    this.setState({ showModal: !this.state.showModal });
  }

  render () {
    const { buttonClass, buttonText, listing, origin } = this.props;
    return (
      <div>
        <button onClick={this.openShareModal} className={`btn btn-default ${buttonClass || ''}`}>
          <img
            src="/web-2/assets/images/share.svg?v=rb"
            alt="share"
            className={`share-img ${buttonText ? 'small-padding-right' : ''}`}
          />
          {
            buttonText && <span>{buttonText}</span>
          }
        </button>
        <BootstrapModal
          showModal={this.state.showModal}
          onClose={this.openShareModal}
          modalSize="sm-size"
          modalClass="modal-sm AddonsListingModal"
          header={<h5>Share this listing</h5>}
          body={
            <div className="social-modal">
              <SocialButtons
                listing={listing}
                origin={origin}
              />
            </div>
          }
        />
      </div>
    );
  }
}

ListingShareBtn.propTypes = {
  buttonClass: PropTypes.string,
  buttonText: PropTypes.string,
  origin: PropTypes.string,
  listing: PropTypes.object
};

export default ListingShareBtn;
